import * as R from 'ramda'
export const initialState = {
  modalOpen: false,
  saveButtonLoading: false,
  selectedWebhookSettingIndex: -1,
  webhookSettings: [],
}

export const reducerAction = {
  TURN_OFF_SAVE_BUTTON_LOADING: 'turn off save button loading',
  OPEN_MODAL: 'turn on modal',
  CLOSE_MODAL: 'turn off modal',
  OPEN_ADD_WEBHOOKSETTING_MODAL: 'open add channel modal',
  OPEN_EDIT_WEBHOOKSETTING_MODAL: 'open edit channel modal',
  CREATE_WEBHOOKSETTING: 'create channel',
  UPDATE_WEBHOOKSETTING: 'update channel',
  DELETE_WEBHOOKSETTING: 'delete channel',
  SET_WEBHOOKSETTING_DATA: 'set channel data',
  UPDATE_WEBHOOK_EVENT: 'update webhook event',
}

/**
 * @typedef State
 * @property {boolean} modalOpen
 * @property {boolean} saveButtonLoading
 * @property {number} selectedWebhookSettingIndex
 * @property {array} webhookSettings
 *
 * @typedef {object} Action
 * @property {string} type
 * @property {object=} payload
 *
 *
 * @param {State} state
 * @param {Action} action
 */
export function reducer(state = initialState, action) {
  if (action.type === reducerAction.TURN_OFF_SAVE_BUTTON_LOADING) {
    return { ...state, saveButtonLoading: false }
  }

  if (action.type === reducerAction.OPEN_MODAL) {
    return { ...state, modalOpen: true }
  }

  if (action.type === reducerAction.CLOSE_MODAL) {
    return { ...state, modalOpen: false }
  }

  if (action.type === reducerAction.OPEN_ADD_WEBHOOKSETTING_MODAL) {
    return {
      ...state,
      selectedWebhookSettingIndex: -1,
      modalOpen: true,
    }
  }

  if (action.type === reducerAction.OPEN_EDIT_WEBHOOKSETTING_MODAL) {
    return {
      ...state,
      selectedWebhookSettingIndex: action.payload.selectedWebhookSettingIndex,
      modalOpen: true,
    }
  }

  if (action.type === reducerAction.CREATE_WEBHOOKSETTING) {
    return {
      ...state,
      webhookSettings: state.webhookSettings.concat(action.payload.webhookSetting),
      selectedWebhookSettingIndex: state.webhookSettings.length,
      saveButtonLoading: action.payload.saveButtonLoading,
    }
  }

  if (action.type === reducerAction.UPDATE_WEBHOOKSETTING) {
    const selectedWebhookSettingIndex = R.findIndex(
      R.propEq('id', action.payload.webhookSettingId),
      state.webhookSettings
    )
    const webhookSetting = {
      ...state.webhookSettings[selectedWebhookSettingIndex],
      name: action.payload.name,
      url: action.payload.url,
    }
    return {
      ...state,
      webhookSettings: R.update(selectedWebhookSettingIndex, webhookSetting, state.webhookSettings),
    }
  }

  if (action.type === reducerAction.DELETE_WEBHOOKSETTING) {
    return {
      ...state,
      webhookSettings: R.remove(
        action.payload.selectedWebhookSettingIndex,
        1,
        state.webhookSettings
      ),
    }
  }

  if (action.type === reducerAction.SET_WEBHOOKSETTING_DATA) {
    return { ...state, webhookSettings: action.payload.webhookSettings }
  }

  if (action.type === reducerAction.UPDATE_WEBHOOK_EVENT) {
    const selectedWebhookSettingIndex = R.findIndex(
      R.propEq('url', action.payload.webhookSetting.url)
    )(state.webhookSettings)
    const surveyIndex = R.findIndex(R.propEq('token', action.payload.surveyToken))(
      state.webhookSettings[selectedWebhookSettingIndex].surveys
    )
    return {
      ...state,
      webhookSettings: R.assocPath(
        [
          selectedWebhookSettingIndex,
          'surveys',
          surveyIndex,
          'event',
          action.payload.eventType,
          action.payload.eventName,
        ],
        action.payload.value,
        state.webhookSettings
      ),
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/WebhookIntegration/reducer.js